import Vue from 'vue'
import VueRouter from 'vue-router'
// import { getToken } from '@/utils/auth'
// import { auth } from '@/plugins/Auth'

Vue.use(VueRouter)
import houseRouter from './modules/house'
import external from './modules/external'
import deliveryRouter from './modules/delivery'
// import sDeliveryRouter from './modules/sidebar/delivery'
// import broadcastingCenterRouter from './modules/sidebar/broadcastingCenter'
import constructionDeliveryRouter from './modules/constructionDelivery'
import customerManagerRouter from './modules/customerManager'
import designManagerRouter from './modules/designManager'
import radRouter from './modules/rad/rad1'
import customerCenter from './modules/customerCenter'
import radTwoRouter from './modules/rad/radTwo'
import radThreeRouter from './modules/rad/radThree'
import designRouter from './modules/design'
import storeManager from './modules/storeManager'
import common from './modules/common'
import customerConsultantRouter from './modules/customerConsultant'
import radDownPageRouter from './modules/radDownPage'
import engineeringManagerRouter from './modules/engineeringManager'
import visitRecordRouter from './modules/visitRecord'
import serviceSystemRouter from './modules/serviceSystem'
import contractRouter from './modules/contract'
import sideBarBroadcastingCenterRouter from './modules/slideBar/broadcastingCenter'
import slideBarDeliveryRouter from './modules/slideBar/delivery'
import slideBarRouter from './modules/slideBar'
import complaintEvaluateRouter from './modules/sidebar/complaintEvaluate'
import customerComplaintRouter from './modules/customerComplaint'
import humanResourcesRouter from './modules/humanResources'
import userProfileRouter from './modules/userProfile'
import bulletinBoardRouter from './modules/bulletinBoard'
import warehouseClerkRouter from './modules/warehouseClerk'
import checkEvaluation from './modules/checkEvaluation'
import userEvaluation from './modules/userEvaluation'
import driver from './modules/driver'
import surveyorRouter from './modules/surveyor'
import manpowerRecruitment from '@/router/modules/manpowerRecruitment'
import recruit from '@/router/modules/recruit'
import singleGoods from '@/router/modules/singleGoods'
import newRadOneRouter from '@/router/modules/rad/newRadOne'

let routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/home'),
    meta: {
      title: '7+1服务'
    }
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home/home'),
    meta: {
      title: '7+1服务'
    }
  },
  // TODO:侧边栏新改版的home页
  {
    path: '/slideBarHome',
    name: 'SlideBarHome',
    component: () => import('@/views/slideBar'),
    meta: {
      title: '7+1服务'
    }
  },
  {
    path: '/autoLogin',
    name: 'autoLogin',
    component: () => import('@/views/autoLogin'),
    meta: {
      title: '7+1服务'
    }
  },
  {
    path: '/noAuth',
    name: 'no-auth',
    component: () => import('@/views/error/no-auth'),
    meta: {
      title: '7+1服务'
    }
  },
  {
    path: '/noReport',
    name: 'noReport',
    component: () => import('@/views/error/no-report'),
    meta: {
      title: '7+1服务'
    }
  },
  {
    path: '/noMeasureReport',
    name: 'noMeasureReport',
    component: () => import('@/views/error/no-measure-report'),
    meta: {
      title: '7+1服务'
    }
  },
  {
    path: '/noProgramme',
    name: 'noProgramme',
    component: () => import('@/views/error/no-programme'),
    meta: {
      title: '7+1服务'
    }
  },
  {
    path: '/noFlockId',
    name: 'noFlockId',
    component: () => import('@/views/error/no-flock-id'),
    meta: {
      title: '7+1服务'
    }
  },
  { path: '*', redirect: '/cNoUser' },
  ...common,
  external
]
// export let asyncRoutes = [
//   // 404 page must be placed at the end !!!
//   { path: '*', redirect: '/404', hidden: true }
// ]
routes = routes
  .concat(houseRouter)
  .concat(deliveryRouter)// 交付在线小程序路由
  .concat(designManagerRouter)
  // .concat(sDeliveryRouter)// 交付在线侧边栏路由
  // .concat(broadcastingCenterRouter)
  .concat(constructionDeliveryRouter)
  .concat(customerManagerRouter)
  .concat(radRouter)
  .concat(radTwoRouter)
  .concat(surveyorRouter)
  .concat(radThreeRouter)
  .concat(recruit)
  .concat(singleGoods)
  .concat(customerCenter)
  .concat(designRouter)
  .concat(storeManager)
  .concat(customerConsultantRouter)
  .concat(radDownPageRouter)
  .concat(engineeringManagerRouter)
  .concat(visitRecordRouter)
  .concat(serviceSystemRouter)
  .concat(contractRouter)
  .concat(sideBarBroadcastingCenterRouter)
  .concat(slideBarDeliveryRouter)
  .concat(slideBarRouter)
  .concat(complaintEvaluateRouter)
  .concat(customerComplaintRouter)
  .concat(humanResourcesRouter)
  .concat(userProfileRouter)
  .concat(bulletinBoardRouter)
  .concat(manpowerRecruitment)
  .concat(warehouseClerkRouter)
  .concat(checkEvaluation)
  .concat(userEvaluation)
  .concat(driver)
  .concat(newRadOneRouter)

const router = new VueRouter({
  routes,
  mode: 'history'
})

// const whiteList = ['/user-cover'] // 不需要token 的白名单

// router.beforeEach((to, from, next) => {
//   if (whiteList.indexOf(to.path) !== -1) {
//     return next()
//   }

//   if (!getToken()) {
//     auth.goAuth(encodeURIComponent(location.href))
//   }
//   next()
// })
export default router
